"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSelectStore = void 0;
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var SearchSelectStore = (function () {
    function SearchSelectStore(popoverWidth) {
        var _this = this;
        this.isOpen = false;
        this.selection = null;
        this.options = [];
        this.search = '';
        this.invokeKeyPress = 'NONE';
        this.hasChange = false;
        this.enableFilter = false;
        this.showTooltip = false;
        this.showTooltipWithDisabled = function (disabled) { return function () {
            if (disabled) {
                return;
            }
            _this.setShowTooltip(true);
        }; };
        this.hideToolTip = function () {
            _this.setShowTooltip();
        };
        this.setShowTooltip = function (showTooltip) {
            if (showTooltip === void 0) { showTooltip = false; }
            _this.showTooltip = showTooltip;
        };
        this.setIsOpen = function (isOpen) {
            _this.isOpen = isOpen;
        };
        this.handleIsOpen = function (isOpen) { return function () {
            _this.setIsOpen(isOpen);
        }; };
        this.setSelection = function (selection) {
            _this.selection = selection;
        };
        this.setOptions = function (options) {
            _this.options = options;
        };
        this.setSearch = function (search) {
            _this.search = search;
        };
        this.setInvokeKeyPress = function (invokeKeyPress) {
            _this.invokeKeyPress = invokeKeyPress;
        };
        this.setHasChange = function (hasChange) {
            _this.hasChange = hasChange;
        };
        this.setPopoverWidth = function (popoverWidth) {
            _this.popoverWidth = popoverWidth;
        };
        this.setEnableFilter = function (enableFilter) {
            _this.enableFilter = enableFilter;
        };
        this.popoverWidth = popoverWidth;
    }
    Object.defineProperty(SearchSelectStore.prototype, "arrayOfValues", {
        get: function () {
            var _this = this;
            var displayValues = [];
            if (!(0, lodash_1.isArray)(this.selection) && this.selection) {
                var value = this.options.find(function (el) { return el.value === _this.selection; });
                (value === null || value === void 0 ? void 0 : value.label) && displayValues.push(value === null || value === void 0 ? void 0 : value.label);
            }
            else if ((0, lodash_1.isArray)(this.selection) && this.selection.length) {
                this.options.forEach(function (opt) {
                    var value = _this.selection.some(function (val) { return val === opt.value; });
                    value && displayValues.push(opt === null || opt === void 0 ? void 0 : opt.label);
                });
                this.options.forEach(function (el) { return el.value === _this.selection; });
            }
            return displayValues;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchSelectStore.prototype, "displayTooltip", {
        get: function () {
            return !!this.arrayOfValues.length && this.showTooltip && !this.isOpen;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], SearchSelectStore.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable
    ], SearchSelectStore.prototype, "selection", void 0);
    __decorate([
        mobx_1.observable
    ], SearchSelectStore.prototype, "options", void 0);
    __decorate([
        mobx_1.observable
    ], SearchSelectStore.prototype, "search", void 0);
    __decorate([
        mobx_1.observable
    ], SearchSelectStore.prototype, "invokeKeyPress", void 0);
    __decorate([
        mobx_1.observable
    ], SearchSelectStore.prototype, "hasChange", void 0);
    __decorate([
        mobx_1.observable
    ], SearchSelectStore.prototype, "popoverWidth", void 0);
    __decorate([
        mobx_1.observable
    ], SearchSelectStore.prototype, "enableFilter", void 0);
    __decorate([
        mobx_1.observable
    ], SearchSelectStore.prototype, "showTooltip", void 0);
    __decorate([
        mobx_1.action
    ], SearchSelectStore.prototype, "setShowTooltip", void 0);
    __decorate([
        mobx_1.action
    ], SearchSelectStore.prototype, "setIsOpen", void 0);
    __decorate([
        mobx_1.action
    ], SearchSelectStore.prototype, "setSelection", void 0);
    __decorate([
        mobx_1.action
    ], SearchSelectStore.prototype, "setOptions", void 0);
    __decorate([
        mobx_1.action
    ], SearchSelectStore.prototype, "setSearch", void 0);
    __decorate([
        mobx_1.action
    ], SearchSelectStore.prototype, "setInvokeKeyPress", void 0);
    __decorate([
        mobx_1.action
    ], SearchSelectStore.prototype, "setHasChange", void 0);
    __decorate([
        mobx_1.action
    ], SearchSelectStore.prototype, "setPopoverWidth", void 0);
    __decorate([
        mobx_1.action
    ], SearchSelectStore.prototype, "setEnableFilter", void 0);
    __decorate([
        mobx_1.computed
    ], SearchSelectStore.prototype, "arrayOfValues", null);
    __decorate([
        mobx_1.computed
    ], SearchSelectStore.prototype, "displayTooltip", null);
    return SearchSelectStore;
}());
exports.SearchSelectStore = SearchSelectStore;
